<template lang="pug">
  v-card(color="grey lighten-1" width="100%")
    v-card-title
      h1.subheading.font-weight-regular Revenue
    v-card-text.pt-0
      v-layout(row wrap)
        v-flex
          v-card.border-r-0(min-height="130px")
            v-card-text(style="height: 128px;")
              v-layout(align-center justify-center column fill-height)
                v-progress-circular(v-if="isLoading" size="70" width="7" indeterminate)
                animated-number.display-1.font-weight-light(v-if="!isLoading" :value="totalRevenue.thisMonth" :formatValue="formatToPrice" :duration="1000")
                div.text-xs-center.caption.font-weight-regular.green--text(color="grey lighten-1") Total Current Month
            v-card-actions
              v-card(color="grey lighten-1" width="100%")
                v-card-text
                  v-layout(align-center justify-center row fill-height)
                    div.text-xs-center.caption(v-if="totalRevenue.previousMonthCurrentDate > totalRevenue.thisMonth")
                      v-icon(small color="red") arrow_downward
                      span {{currentMonthRevenuePercentage}}% Decrease
                      span ({{totalRevenue.previousMonthCurrentDate}})
                    div.text-xs-center.caption(v-else)
                      v-icon(small color="green") arrow_upward
                      span {{currentMonthRevenuePercentage}}% Increase
                      span ({{totalRevenue.previousMonthCurrentDate}})
        v-flex
          v-card.border-r-0(min-height="130px")
            v-card-text(style="height: 128px;")
              v-layout(align-center justify-center column fill-height)
                v-progress-circular(v-if="isLoading" size="70" width="7" indeterminate)
                animated-number.display-1.font-weight-light(v-if="!isLoading" :value="totalRevenue.previousMonth" :formatValue="formatToPrice" :duration="1000")
                div.text-xs-center.caption.font-weight-regular.green--text Total Previous Month
            v-card-actions
              v-card(color="grey lighten-1" width="100%")
                v-card-text
                  v-layout(align-center justify-center row fill-height)
                    div.text-xs-center.caption(v-if="totalRevenue.oneBeforePreviousMonth > totalRevenue.previousMonth")
                      v-icon(small color="red") arrow_downward
                      span {{previousMonthRevenuePercentage}}% Decrease
                      span ({{totalRevenue.oneBeforePreviousMonth}})
                    div.text-xs-center.caption(v-else)
                      v-icon(small color="green") arrow_upward
                      span {{previousMonthRevenuePercentage}}% Increase
                      span ({{totalRevenue.oneBeforePreviousMonth}})
</template>

<script>
import dashbaordService from '../../service.js'
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      totalRevenue: {
        thisMonth: 0.00,
        previousMonthCurrentDate: 0.00,
        previousMonth: 0.00,
        oneBeforePreviousMonth: 0.00

      },
      isLoading: true
    }
  },
  components: {
    AnimatedNumber
  },
  async mounted() {
    await this.setRevenue()
    this.isLoading = false
  },
  computed: {
    currentMonthRevenuePercentage () {
      var value = this.totalRevenue.thisMonth - this.totalRevenue.previousMonthCurrentDate
      if (value !== 0) {
        return (value / this.totalRevenue.previousMonthCurrentDate * 100).toFixed(2)
      } else {
        return 0
      }
    },
    previousMonthRevenuePercentage () {
      var value = this.totalRevenue.previousMonth - this.totalRevenue.oneBeforePreviousMonth
      if (value !== 0) {
        return (value / this.totalRevenue.oneBeforePreviousMonth * 100).toFixed(2)
      } else {
        return 0
      }
    },
  },
  methods: {
    async setRevenue() {
      await this.getRevenueCurrentMonth()
      await this.getRevenuePreviousMonth()
    },
    formatToPrice(value) {
      return `$ ${value.toFixed(2)}`;
    },
    getRevenueCurrentMonth() {
      dashbaordService.getRevenueCurrentMonth({month: 'current'})
      .then(result => {
        this.totalRevenue.thisMonth = parseFloat(result.data.givenMonth.revenue)
        this.totalRevenue.previousMonthCurrentDate = parseFloat(result.data.previousOfGivenMonth.revenue)
        return true
      })
    },
    getRevenuePreviousMonth() {
      dashbaordService.getRevenuePreviousMonth({month: 'previous'})
      .then(result => {
        this.totalRevenue.previousMonth = parseFloat(result.data.givenMonth.revenue)
        this.totalRevenue.oneBeforePreviousMonth = parseFloat(result.data.previousOfGivenMonth.revenue)
        return true
      })
    },
  }
}
</script>

<style scoped>
</style>